module.exports = __webpack_public_path__ + "img/print_template_avatar.31800dbc.svg";